import __var_0__ from '@stdlib/math/base/tools/evalpoly';
import __var_1__ from '@stdlib/math/base/special/pow';
import __var_2__ from '@stdlib/math/base/special/abs';
import __var_3__ from './coefficients.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var evalpoly = __var_0__;
var pow = __var_1__;
var abs = __var_2__;
var coefficients = __var_3__;


// MAIN //

/**
* Evaluates a Fibonacci polynomial.
*
* @param {integer} n - Fibonacci polynomial to evaluate
* @param {number} x - value at which to evaluate a Fibonacci polynomial
* @returns {number} result
*
* @example
* var v = fibpoly( 5, 1.0 );
* // returns 5.0
*/
function fibpoly( n, x ) {
	var coefs;
	var an;
	var v;

	an = abs( n );
	coefs = coefficients( an );

	v = evalpoly( coefs, x );
	if ( n >= 0 ) {
		return v;
	}
	return pow( -1.0, an-1 ) * v;
}


// EXPORTS //
export default fibpoly;
